// Logo interno TORRI.SOLAR — pittogramma "T" accostato al testo (Arial) su due righe.
export function TorriLogo({ className = "", imgClass = "h-11" }) {
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="torri-logo" style={{ fontFamily: "Arial, Helvetica, sans-serif" }}>
      <img src="/torri-mark.png" alt="TORRI.SOLAR" className={`${imgClass} w-auto object-contain`} />
      <div className="leading-tight text-center">
        <div className="text-[16px] font-bold uppercase tracking-tight text-foreground">TORRI<span className="text-primary">.SOLAR</span></div>
        <div className="text-[9px] font-normal uppercase tracking-[0.14em] text-muted-foreground">Div. Installatori</div>
      </div>
    </div>
  );
}

// Marchio compatto (cerchio giallo trasparente) per spazi ristretti.
export function TorriMark({ className = "h-9 w-9" }) {
  return <img src="/torri-mark.png" alt="TORRI" className={`${className} object-contain`} data-testid="torri-mark" />;
}
